export const parseUrl = (url) => {
  if (url.slice(0, 4) !== 'http') {
    return `http://${url}`
  }
  return url
}



// WEBPACK FOOTER //
// ./src/pages/index/assets/js/common.js